(function() {
'use strict'

AppTabs.createTab( {
	name: 'quote',
	icon: 'file-invoice-dollar',
	text: 'Quote',
	create: function(init) {
		const tab = this;
		const anchor = document.getElementById('download-quote-anchor');
		const span = document.getElementById('quote-filename');
		let quoteObject = null;
		let objectURL = null;
		function reset() {
			if (quoteObject != null)
				tab.container.removeChild(quoteObject);

			if (objectURL != null)
				URL.revokeObjectURL(objectURL);
		}

		init.setController( {
			OpenQuote(quoteID) {
				reset();
				const request = new XMLHttpRequest();
				request.open('POST', ajax_object.ajax_url, true);
				request.responseType = 'blob';
				request.onload = function() {
					objectURL = URL.createObjectURL(request.response);
					quoteObject = document.createElement('object')
					//quoteObject = document.createElement('iframe')
					quoteObject.setAttribute('style', 'margin:0;padding:0;width:100%;height:100%;border:none;');
					quoteObject.setAttribute('type', request.getResponseHeader("Content-Type"));
					quoteObject.setAttribute('data', objectURL);
					//quoteObject.setAttribute('src', objectURL);
					tab.container.appendChild(quoteObject);

					// "Content-Disposition:inline;filename=\"filename\""
					const contentDisposition = request.getResponseHeader("Content-Disposition");
					if (contentDisposition) {
						let parts = contentDisposition.split('=');
						if (parts.length > 1 && parts[1])
							anchor.download = decodeURIComponent(parts[1].substring(1, parts[1].length - 1).replace(/\+/g, '%20'));

						if (!anchor.download)
							anchor.download = 'Quote--' + quoteID + '.pdf';
					}

					anchor.href = objectURL;
					span.innerText = anchor.download;
				};
				request.onerror = function() {
					quoteObject = document.createElement('div');
					quoteObject.setAttribute('style', 'margin:3em;width:auto;height:auto;text-align:center;');
					quoteObject.innerText = request.statusText;
					tab.container.appendChild(quoteObject);
				};
				request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
				request.send(JSON.stringify( {
					session_id: ajax_object.session_id,
					action: 'generate_quote_pdf',
					quoteID: quoteID,
				} ));
				tab.show();
			},
			onTabClose() {
				reset();
			},
		} );
	}
});

})();